import { render } from "./SearchResultsCategory.vue?vue&type=template&id=270a8de0&scoped=true"
import script from "./SearchResultsCategory.vue?vue&type=script&lang=js"
export * from "./SearchResultsCategory.vue?vue&type=script&lang=js"

import "./SearchResultsCategory.vue?vue&type=style&index=0&id=270a8de0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-270a8de0"]])

export default __exports__